import styled from 'styled-components/macro';
import { COLORS } from 'styleguide';

const LineStub = styled.div`
  width: 120px;
  height: 16px;
  background-color: ${COLORS.line};
`;

export default LineStub;
